import "./login_email.mcss";
import "@bux/input/text/string.mts";

import { SEC } from "@arlib/lib.mts";
import { type Option, Uuid } from "@artyp/lib.mts";
import { copy_view, make_view } from "@bux/document/mod.mts";
import { go_next } from "@bux/singleton/nav_stack.mts";
import { request_code, verify_code } from "./login_emailλ.mts";

import BuxInputTextString from "@bux/input/text/string.mts";

const $views = SEC(HTMLDivElement, document, "#views");
const $wrapper = SEC(HTMLElement, document, "#wrapper");
const next_uri = $wrapper.dataset["nextUri"] ?? null;

function enter_email_state() {
    const $view = copy_view("enter_email");
    const $form = SEC(HTMLFormElement, $view, "form");
    const $email = SEC(BuxInputTextString, $view, "[name=email]");

    $form.addEventListener("submit", async (event: Event) => {
        event.preventDefault();
        await submit();
    });

    $views.replaceChildren($view);

    async function submit() {
        $views.replaceChildren(make_view(
            "processing",
            `
            <p>Processing...</p>
        `,
        ));

        const output = await request_code.call({
            email: $email.value ?? null,
        });

        if ("Error" in output) {
            $views.replaceChildren($view);
            $email.set_e(output.Error.message);
            $form.reportValidity();
            return;
        }

        if ("Disabled" in output) {
            $views.replaceChildren($view);
            $email.set_e("Emailed code login is currently disabled for this application.");
            $form.reportValidity();
            return;
        }

        return enter_code_state({
            auth_email_uuid: output.Ok.auth_email_uuid,
            from_address: output.Ok.from_address,
            from_name: output.Ok.from_name,
            subject: output.Ok.subject,
        });
    }
}

function enter_code_state(
    trans: { auth_email_uuid: Uuid; from_address: string; from_name: Option<string>; subject: string; },
) {
    const $view = copy_view("verify_code");
    const $form = SEC(HTMLFormElement, $view, "form");
    const $code = SEC(BuxInputTextString, $view, "[name=code]");
    const $email_info = SEC(HTMLElement, $view, "email-sent-info");
    $email_info.textContent = [
        `From: ${trans.from_name ?? "—"} <${trans.from_address}>`,
        `Subject: ${trans.subject}`,
    ].join("\n");

    $form.addEventListener("submit", async (event: Event) => {
        event.preventDefault();
        await submit();
    });

    $views.replaceChildren($view);

    async function submit() {
        $views.replaceChildren(make_view(
            "processing",
            `
            <p>Processing...</p>
        `,
        ));

        const output = await verify_code.call({
            auth_email_uuid: trans.auth_email_uuid,
            code: $code.value ?? null,
            next_uri,
        });

        if ("InputErr" in output) {
            $views.replaceChildren($view);
            $code.set_e(output.InputErr[0].code ?? null);
            $form.reportValidity();
            return;
        }

        if ("Disabled" in output) {
            $views.replaceChildren($view);
            $code.set_e("Emailed code login is currently disabled for this application.");
            $form.reportValidity();
            return;
        }

        await complete_state(output.Ok.next_uri);
    }
}

async function complete_state(next_uri: string) {
    $views.replaceChildren(copy_view("success"));
    go_next(next_uri);
}

enter_email_state();
